import React, { useEffect } from 'react';
import Editor, { useMonaco } from '@monaco-editor/react';
import { Form } from 'antd';

const jsLibraryTypes = `
declare const user: {
  name: string;
  points: number;
  role: "viewer" | "subscriber" | "mod" | "broadcaster";
  followStatus: "follower" | "subscriber";
  watchTime: number;
};

declare function sendMessage(msg: string): void;
`;

const DEFAULT_CODE = `// Example:
// USER HAVE NEXT FIELDS

// user: {
//   name: string;
//   points: number;
//   role: "viewer" | "subscriber" | "mod" | "broadcaster";
//   followStatus: "follower" | "subscriber";
//   watchTime: number;
// }

// 

if (user.points > 100) {
  sendMessage(\`Congrats \${user.username}, you have more than 100 points!\`);
}
`;

export const FormCode = (props) => {
  const {
    name,
    label,
    required = false,
    hidden
    // formData, // you receive it from Builder, but we don't need it here
  } = props;

  const monaco = useMonaco();

  // Init Monaco types (JS project is fine – this is just a .d.ts string)
  useEffect(() => {
    if (!monaco) return;

    monaco.languages.typescript.javascriptDefaults.addExtraLib(
      jsLibraryTypes,
      'ts:global-user.d.ts'
    );

    monaco.languages.typescript.javascriptDefaults.setEagerModelSync(true);
  }, [monaco]);

  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={DEFAULT_CODE} // 🔹 default content
      rules={required ? [{ required: true, message: 'Required field' }] : []}
      hidden={hidden}
      preserve
      // Editor's prop is called "value", so default is fine:
      valuePropName="value"
      // map Monaco's onChange(value, ev) -> form field value
      getValueFromEvent={(...args) => {
        const val = args[0]; // first arg is the code string
        return val ?? '';
      }}
    >
      <Editor
        height={300}
        language="javascript"
        theme="vs-dark"
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          scrollBeyondLastLine: false,
          automaticLayout: true
        }}
      />
    </Form.Item>
  );
};
